import { createTheme } from '@material-ui/core';

const theme = createTheme({
  palette: {
    primary: {
      light: '#fa6262',
      main: '#c4333d'
    },
    secondary: {
      light: '#a7eea9',
      main: '#4cb050'
    }
  }
});

export default theme;
